<template>
  <div class="bgfff">
    <div class="w1200">
      <div class="outsideTop">
        <div class="left" @click="$router.push('/goodsList?page=newFlag')">
          <a href="javascript:void(0)" class="jumpHome">
            <img src="@/assets/img/nk_logo.png" class="nk]_logo" alt="">
          </a>
          <span class="shopname">挪客商城</span>
        </div>
        <div class="right" v-if="userInfo.loginName == null ? true : false">
          <span class="accountCom" @click="openDia(1)" style="margin-right:6px;">
            核算公司：{{userInfo.brand}}
            <span class="dot"></span>
            <span style="color:#34A853;">【切换】</span>
          </span>
          <a href="/#/goodsList?page=newFlag">商城首页</a>
          <a href="/#/login">我要登录</a>
          <a href="/#/register">注册账号</a>
          <a href="/#/retrievePassword">找回密码</a>
        </div>
        <div class="useredRight" v-if="userInfo.loginName == null ? false : true">
          <span class="accountCom" @click="openDia(2)">
            核算公司：{{userInfo.brand}}
            <span class="dot"></span>
            <span style="color:#34A853;">【切换】</span>
          </span>
          <el-popover placement="top-start" trigger="hover" popper-class="usernameClass" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a v-on:click.stop="exit" href="javascript:void(0)">退出登录</a>
            </div>
            <span class="el-dropdown-link" slot="reference">
              {{userInfo.userName||userInfo.loginName}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/myInfomation">个人信息</a>
              <a href="/#/userCenter?tap=3">账号安全</a>
              <a href="/#/rebate" v-if="userInfo.isSeeBack=='1'">返利管理</a>
              <a href="/#/address">收货地址</a>
              <a href="/#/myStripe" v-if="userInfo.isHaveWhiteNote">我的授信</a>
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              个人中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/myOrderRight">我的订单</a>
              <a href="/#/invoicingPage" v-if="isgrayscale&&userInfo.accountingCompanyCode==102">申请开票</a>
              <a href="/#/invoiceList" v-if="isgrayscale&&userInfo.accountingCompanyCode==102">发票管理</a>
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              订单中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top-start" trigger="hover" popper-class="tabPopover" :close-delay="50" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/refund">我的售后</a>
              <!-- <a href="/#/consultation">商品咨询</a> -->
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              客户服务
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
          <el-popover placement="top" trigger="hover" :close-delay="50" popper-class="tabPopover" :visible-arrow="true">
            <div class="openPopover">
              <a href="/#/paymentCenter?tap=1">交易明细</a>
              <a href="/#/paymentCenter?tap=0">转账明细</a>
              <a href="/#/paymentCenter?tap=2">账户余额</a>
            </div>
            <span class="el-dropdown-link" slot="reference" v-if="userInfo.userId&&userInfo.userId!=10853">
              财产中心
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
          </el-popover>
        </div>
      </div>
    </div>

    <el-dialog title="所有核算公司" :visible.sync="isOpen" width="500px">
      <el-table :data="brandLIst" size="small" stripe border style="width: 100%">
        <el-table-column prop="accountingCompanyName" label="名称">
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="changeCom(scope.row,scope.$index)" :loading="scope.row.loading" type="primary" size="mini">切换</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import { brandList, changeBrand, postInfo } from "@/api/xunyou";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      brandLIst: [],
      isOpen: false,
      isbtn: false,
      cliVal: 1
    };
  },
  computed: {
    isgrayscale() {
      return this.$store.state.grayscale;
    }
  },
  created() {},
  methods: {
    changeCom(v, i) {
      if (this.isbtn) {
        return;
      }
      this.isbtn = true;
      v.loading = true;
      this.brandLIst.splice(i, 1, v);
      if (this.cliVal == 2) {
        changeBrand({
          uid: this.userInfo.userId || "",
          accountingCompanyCode: v.accountingCompanyCode
        })
          .then(res => {
            if (res.code == "0") {
              postInfo({
                uid: this.userInfo.userId || "",
                userToken: this.userInfo.userToken || ""
              })
                .then(res2 => {
                  this.isOpen = false;
                  v.loading = false;
                  this.brandLIst.splice(i, 1, v);
                  if (res2.code == 0) {
                    this.userInfo.accountingCompanyCode =
                      v.accountingCompanyCode;
                    this.userInfo.brand = v.accountingCompanyName;
                    if (res2.data.payMethod == "balance") {
                      this.userInfo.isHaveWhiteNote = 0;
                    } else if (res2.data.payMethod == "whiteNote") {
                      this.userInfo.isHaveWhiteNote = 1;
                    }
                    this.$message({
                      message: "切换成功",
                      type: "success",
                      duration: 1500
                    });
                    // console.log(this.userInfo.isHaveWhiteNote, "isHaveWhiteNote");
                    sessionStorage.clear();
                    localStorage.clear();
                    localStorage.setItem(
                      "userdata",
                      JSON.stringify(this.userInfo)
                    );
                    // console.log(JSON.parse(localStorage.getItem("userdata")),"userdata");
                    this.$router.replace("/goodsList?page=newFlag");
                    this.$store.dispatch("getshoppingCartlist"); // 购物车
                    this.$store.dispatch("getCategoryList"); //全部商品分类
                    this.$store.dispatch("getNavList"); //获取导航栏列表
                  }
                  this.isbtn = false;
                })
                .catch(err => {
                  this.$message.error(JSON.stringify(err));
                  this.isbtn = false;
                });
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            this.$message.error(JSON.stringify(err));
            this.isbtn = false;
          });
      } else if (this.cliVal == 1) {
        // 未登录
        this.userInfo.accountingCompanyCode = v.accountingCompanyCode;
        this.userInfo.brand = v.accountingCompanyName;
        sessionStorage.clear();
        localStorage.setItem("userdata", JSON.stringify(this.userInfo));
        this.isOpen = false;
        v.loading = false;
        this.brandLIst.splice(i, 1, v);
        this.isbtn = false;
        this.$message({
          message: "切换成功",
          type: "success",
          duration: 1000
        });
        this.$router.replace("/goodsList?page=newFlag");
      }
    },
    openDia(val) {
      this.cliVal = val;
      this.brandLIst = [];
      if (val == 2) {
        // 已登录
        this.isOpen = true;
        brandList({
          uid: this.userInfo.userId || ""
        })
          .then(res => {
            if (res.code == "0") {
              res.data.forEach(element => {
                element.loading = false;
              });
              this.brandLIst = res.data;
            } else {
              this.$message.error(res.msg);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else if (val == 1) {
        this.isOpen = true;
        this.brandLIst = [
          {
            accountingCompanyCode: "102",
            accountingCompanyName: "宁波市云汭旅游用品有限公司"
          },
          {
            accountingCompanyCode: "106",
            accountingCompanyName: "宁波市黑狗户外用品有限公司"
          },
          {
            accountingCompanyCode: "117",
            accountingCompanyName: "浙江挪客森林服饰有限公司"
          }
        ];
      }
    },
    exit() {
      let userObj = JSON.parse(localStorage.getItem("userdata")) || {};
      let strObj = {};
      if (userObj.accountingCompanyCode) {
        strObj = {
          accountingCompanyCode: userObj.accountingCompanyCode,
          brand: userObj.brand
        };
      } else {
        strObj = {
          accountingCompanyCode: 102,
          brand: "宁波市云汭旅游用品有限公司"
        };
      }
      sessionStorage.clear();
      localStorage.clear();
      localStorage.setItem("userdata", JSON.stringify(strObj));
      this.userInfo = {};
      this.$store.commit("getCartList", []);
      this.$router.push("/goodsList?page=newFlag");
    }
  }
};
</script>


<style scoped lang="less">
.accountCom {
  display: inline-block;
  padding: 6px 8px;
  background: #e4e7ed;
  cursor: pointer;
  border-radius: 5px;
  font-size: 14px;
  .dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #34a853;
  }
}
.bgfff {
  border-bottom: 2px solid #ea0a2a;
  .w1200 {
    margin: 0 auto;
    .outsideTop {
      display: flex;
      justify-content: space-between;
      align-items: end;
      padding: 12px 16px;
      .left {
        .jumpHome {
          display: inline-block;
          box-sizing: border-box;
          img {
            height: 60px;
          }
        }
        .shopname {
          display: inline-block;
          font-size: 22px;
          vertical-align: bottom;
          line-height: 20px;
          font-weight: 600;
          padding-bottom: 10px;
          cursor: pointer;
        }
      }
      .right {
        display: flex;
        align-items: center;
        a {
          font-size: 16px;
          position: relative;
          padding-right: 20px;
          &:not(:last-child)::after {
            content: "";
            position: absolute;
            height: 80%;
            width: 2px;
            background: #c0c4cc;
            top: 50%;
            transform: translateY(-50%);
            right: 10px;
          }
          &:last-child {
            padding-right: 0px;
          }
        }
      }
      .useredRight {
        font-size: 14px;
        .el-icon--right {
          margin-left: 0px;
          font-weight: 600px;
        }
      }
    }
  }
}

.el-dropdown-link {
  margin-left: 20px;
  &:hover {
    color: rgba(234, 10, 42, 1);
    cursor: pointer;
  }
}

.openPopover {
  max-width: 600px;
  display: flex;
  flex-wrap: wrap;
  a {
    margin-right: 12px;
    display: inline-block;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/outsideTop.vue